module.exports = __webpack_public_path__ + "static/media/kopila_put_book_to_bag.d0a3fd82.gif";